import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface StarredState {
  ids: string[];
  toggle: (id: string) => void;
  isStarred: (id: string) => boolean;
  clear: () => void;
}

/**
 * User's starred (favourite) workflows. Persisted to localStorage so
 * the user's curated subset survives reloads. Default empty — UI
 * shows "all" when no stars exist; once any workflow is starred,
 * "favoritos" becomes the default filter.
 */
export const useStarred = create<StarredState>()(
  persist(
    (set, get) => ({
      ids: [],
      toggle: (id) =>
        set((s) => ({
          ids: s.ids.includes(id) ? s.ids.filter((x) => x !== id) : [...s.ids, id],
        })),
      isStarred: (id) => get().ids.includes(id),
      clear: () => set({ ids: [] }),
    }),
    { name: 'wiredesk-starred-workflows' },
  ),
);
